import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AnalysisApiClient, ApplicationApiClient } from '@nk/api-client-lib';
import { StorageService } from '@nk/storage-lib';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@nk/shared/shared.module';

@Component({
  selector: 'nk-maintenance-view',
  imports: [CommonModule, RouterModule, TranslateModule, SharedModule],
  templateUrl: 'maintenance-view.component.html',
})
export class MaintenanceViewComponent {
  public redirectBackUrl: string;
  public isFirstCheck = true;
  public isLoading: boolean;

  constructor(
    private _storageService: StorageService,
    private _router: Router,
    private _analysisApi: AnalysisApiClient,
    private _applicationApi: ApplicationApiClient,
  ) {
    const redirectBackUrl = this._storageService.getItem('maintenance.redirect_back_url');
    if (typeof redirectBackUrl === 'string' && redirectBackUrl !== '' && redirectBackUrl !== 'maintenance') {
      this.redirectBackUrl = `/${redirectBackUrl}`;
    } else {
      this.redirectBackUrl = '/';
    }
    this.navigateBack();
  }

  public navigateBack(): void {
    this.isLoading = true;
    forkJoin([
      this._applicationApi.get('system-status', {}, null),
      this._analysisApi.get('system-status', {}, null),
    ]).subscribe({
      next: () => {
        console.info('Connection to Enin and application analysis api restored');
        this._router.navigateByUrl(this.redirectBackUrl);
        this._storageService.clearNamespace('maintenance');
        this.isLoading = false;
      },
      error: () => {
        this.isFirstCheck = false;
        this.isLoading = false;
      },
    });
  }
}
